import { Logo } from "./Logo";
import { Marquee } from "./Marquee";

export const TrustedByLogos = () => (
  <Marquee speed={0.25} className="py-2">
    <Logo company="Adobe" className="mx-6 inline-block h-8 opacity-20" />
    <Logo company="Webflow" className="mx-6 inline-block h-8 opacity-20" />
    <Logo company="SpaceX" className="mx-6 inline-block h-8 opacity-20" />
    <Logo company="Miro" className="mx-6 inline-block h-8 opacity-20" />
    <Logo company="Harvard" className="mx-6 inline-block h-8 opacity-20" />
  </Marquee>
);
